import queryString from 'query-string-es5';
import * as React from "react";
import { hot } from "react-hot-loader";
import Captcha from "react-numeric-captcha";
import { Link } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import DataProvider from '../../dataproviders/DataProvider';
import DataProviderSharePoint from '../../dataproviders/DataProvidersSharePoint';
import { ICategorie } from '../../interfaces/ICategorie';
import { ICategorieInfo } from '../../interfaces/ICategorieInfo';
import { IInputFormSharePoint } from '../../interfaces/IInputFormSharePoint';
import { IInputValidation } from '../../interfaces/IInputValidation';
import EnmUtils from '../../utils/EnmUtils';
import CustomLoader from '../CustomLoader/CustomLoader';
import FormulaireCategorie from './FormulaireCategorie/FormulaireCategorie';
import { IFormulaireCandidatureState } from './IFormulaireCandidatureState';

declare var configcustoms: any;
declare var libelle: any;
declare var formulaireCandidature: any;
declare var formulaireAllPjList: any;

class FormulaireCandidature extends React.Component<{}, IFormulaireCandidatureState> {

  private _dataProvider = new DataProviderSharePoint();
  private _dataProviderLocal = new DataProvider();

  constructor(props: any) {
    super(props);

    const categorieInfosInit: ICategorieInfo[] = [];
    Object.keys(formulaireCandidature).map((key) => {
      categorieInfosInit[key] = {
        IsValid: false,
      }
    });

    this.state = {
      IsReady: false,
      IsReadOnly: false,
      ObligatoryIsCheck: false,
      AllCategorieIsValid: false,
      AllCategorieIsReady: false,
      ConnectedLogin: EnmUtils.getLoginConnectedUser(),
      AllFormulaire: formulaireCandidature,
      CategorieInfos: categorieInfosInit,
      AllCustomInputInfos: [],
      CandidatureFieldsValue: [],
      IdCandidature: 0,
      InputFormSharePointList: [],
      PJSharePointList: [],
      EtatCandidatureList: [],
      EtatDepotCandidatureList: [],
      captchaIsValid: false,
      NumDossier: '',
      IsSuccessSubmit: false,
      PromotionIsClosed: false
    }

    if (props.location.search != null) {
      const parsedUrl = queryString.parse(props.location.search);
      this.state = {
        ...this.state,
        IdCandidature: parsedUrl.idCandidature,
      }
    }

    this.OnCategorieIsValid = this.OnCategorieIsValid.bind(this);
    this.OnCategorieIsReady = this.OnCategorieIsReady.bind(this);
    this.OnInputChange = this.OnInputChange.bind(this);

    this.handleObligatoryChange = this.handleObligatoryChange.bind(this);
    this.submitCandidature = this.submitCandidature.bind(this);
  }

  public componentDidMount() {
    if (this.state.IdCandidature === 0) {
      return;
    } else {
      Promise.all([this.getEtatDepotCandidature(), this.getEtatCandidature()]).then(values => {
        this.getAllCandidature();
      });
    }
  }

  public render() {
    const categoriesRender = Object.keys(this.state.AllFormulaire).map((key, index) => {
      return (
        <FormulaireCategorie key={key} categorieName={key} categorieFormList={this.state.AllFormulaire[key]} PJSharePointList={this.state.PJSharePointList}
          candidatureId={this.state.IdCandidature} loginName={this.state.ConnectedLogin} InputFormSharePointList={this.state.InputFormSharePointList}
          OnCategorieIsValid={this.OnCategorieIsValid} OnCategorieIsReady={this.OnCategorieIsReady} OnInputChange={this.OnInputChange} />
      );
    });

    const promotionTitle = this.state.CandidatureFieldsValue[0] != null ? this.state.CandidatureFieldsValue[0]['IdPromo_x003a_Titre'] : '';

    const formIsValid = this.state.AllCategorieIsValid && this.state.ObligatoryIsCheck && this.state.captchaIsValid && !this.state.IsReadOnly;

    const captchaErrorClass = this.state.captchaIsValid ? "" : "captcha-error";
    const categoriesInvalidRender = Object.keys(this.state.CategorieInfos).map((key, index) => {
      if (this.state.CategorieInfos[key].IsValid) {
        return;
      }
      return (
        <button className="btn btn-danger btn-sm mr-2 mb-2" key={key} onClick={this.scrollToElementWithId.bind(this, 'heading_' + key)}>
          {libelle.formulaireCandidature[key]}
        </button>
      );
    });

    return (
      <div id="formulaire">
        <CSSTransition
          classNames="loader"
          in={!this.state.IsReady}
          timeout={300}
          unmountOnExit={true}
        >
          <CustomLoader />
        </CSSTransition>

        <div className="col-12 col-lg-10 offset-lg-1">
          <CSSTransition
            classNames="fadein"
            in={this.state.IsReady && !this.state.IsSuccessSubmit}
            timeout={300}
            unmountOnExit={true}
          >
            <div>
              <h1>{libelle.formulaireCandidature.title} {promotionTitle}</h1>
              {this.state.PromotionIsClosed && this.state.EtatDepotCandidatureList[0] === this.state.CandidatureFieldsValue[0]["EtatDepotCandidature"] &&
                <div className="custom-card p-4 mb-4 bg-danger">
                  <p className="mb-0 text-white"><b>{libelle.formulaireCandidature.promotionClosed}</b></p>
                </div>
              }
              {!this.state.IsReadOnly &&
                <div className="custom-card p-4 mb-4">
                  <p className="mb-0">{libelle.formulaireCandidature.infos}</p>
                </div>
              }
              <div className="accordion" id="accordionForm">
                {categoriesRender}
              </div>
              {!this.state.IsReadOnly &&
                <div>
                  <div className="custom-card mt-4 p-4">
                    <div className={captchaErrorClass}>
                      <Captcha placeholder={libelle.formulaireCandidature.captchaPlaceHolder}
                        onChange={status => this.setState({ captchaIsValid: status })}
                      />
                      {!this.state.captchaIsValid &&
                        <small className="ml-3 text-danger ">Le captcha n'est pas valide</small>
                      }
                    </div>
                    <div className="form-check pt-3">
                      <input className="form-check-input" type="checkbox" checked={this.state.ObligatoryIsCheck} onChange={this.handleObligatoryChange} id="obligatoryCheck" />
                      <label className="form-check-label" htmlFor="obligatoryCheck">
                        {libelle.formulaireCandidature.obligatoryCheck}
                      </label>
                    </div>
                    <div className="pt-3">
                      <a href="" data-toggle="modal" data-target="#modalObligatoryMention">{libelle.formulaireCandidature.obligatoryMentions}</a>
                    </div>
                  </div>
                  {!this.state.AllCategorieIsValid &&
                    <div className="custom-card mt-4 p-4">
                      <h1 className="mb-0">{libelle.formulaireCandidature.categoriesErrors}</h1>
                      <p>{libelle.formulaireCandidature.categoriesErrorsInfo}</p>
                      <div className="pt-2">{categoriesInvalidRender}</div>
                    </div>
                  }
                  <div className="custom-card mt-4 p-4">
                    <div dangerouslySetInnerHTML={{ __html: libelle.formulaireCandidature.rappelPjObligatory }} />
                  </div>
                  <div className="custom-card mt-4 p-4">
                    <div className="text-danger">{libelle.formulaireCandidature.alertValidate}</div>
                  </div>
                  <div className="pt-4 d-flex flex-nowrap justify-content-between">
                    <Link to={configcustoms.Route.Home} >{libelle.formulaireCandidature.btnCancel}</Link>
                    <button type="button" className="btn btn-primary btn-lg" onClick={this.submitCandidature} disabled={!formIsValid}>{libelle.formulaireCandidature.validate}</button>
                  </div>
                </div>
              }
              {this.state.IsReadOnly &&
                <div className="pt-4 d-flex flex-nowrap justify-content-between">
                  <Link to={configcustoms.Route.Home} >{libelle.formulaireCandidature.btnCancel}</Link>
                </div>
              }
            </div>
          </CSSTransition>
          <CSSTransition
            classNames="fadein"
            in={this.state.IsReady && this.state.IsSuccessSubmit}
            timeout={300}
            unmountOnExit={true}
          >
            <div>
              <h1>{libelle.formulaireCandidature.title} {promotionTitle}</h1>
              <div className="custom-card p-4">
                <p>{libelle.formulaireCandidature.successMessage}<b>&nbsp;{this.state.NumDossier}</b></p>
                <p className="mb-0">{libelle.formulaireCandidature.successMessageSuite}</p>
              </div>
              <div className="pt-4 d-flex flex-nowrap flex-row-reverse">
                <Link to={configcustoms.Route.Home}>
                  <button type="button" className="btn btn-primary btn-lg">{libelle.formulaireCandidature.btnCancel}</button>
                </Link>
              </div>
            </div>
          </CSSTransition>
        </div>

      </div >
    );
  }

  private scrollToElementWithId(elementId: string) {
    if (elementId != null && document != null) {
      const element = document.getElementById(elementId);
      if (element != null) {
        element.scrollIntoView({ block: 'start' });
      }
    }
  }

  private handleObligatoryChange(event) {
    const target = event.target;
    const value = target.checked;

    this.setState({
      ObligatoryIsCheck: value
    });
  }

  private submitCandidature(event) {

    this.setState({ IsReady: false });

    // update Depot candidature date
    this._dataProvider.sendInput(this.state.ConnectedLogin, this.state.IdCandidature, 'DateValidDossier', new Date().toISOString(), 'DateTime').then(respValidDossier => {

      // update Depot candidature state
      this._dataProvider.sendInput(this.state.ConnectedLogin, this.state.IdCandidature, 'EtatDepotCandidature', this.state.EtatDepotCandidatureList[1], 'Text').then(respEtatDepot => {

        // update candidature state
        this._dataProvider.sendInput(this.state.ConnectedLogin, this.state.IdCandidature, 'EtatCandidature', this.state.EtatCandidatureList[1], 'Text').then(respEtat => {

          // update AttestHonSignature
          this._dataProvider.sendInput(this.state.ConnectedLogin, this.state.IdCandidature, 'AttestHonSignature', new Date().toISOString(), 'DateTime').then(respSignature => {

            // Le numéro contiendra les 3 premières lettres du nom de famille + l'année de la promotion + la date et heure de la validation définitive du dossier
            const name: string = this.state.InputFormSharePointList['NomDeNaissance'].Value.substring(0, 3);
            const annee: number = this.state.CandidatureFieldsValue[0]['IdPromo_x003a_Ann_x00e9_e'].substring(0, 4);
            const dateNow: Date = new Date();
            const date = EnmUtils.getDateForCandidatureNumber(dateNow.toString()) + "-" + dateNow.getHours() + ":" + dateNow.getMinutes();
            const numeroDossier = name + "_" + annee + "_" + date;

            // Set numéro du dossier dans sharePoint
            this._dataProvider.sendInput(this.state.ConnectedLogin, this.state.IdCandidature, 'NumDossier', numeroDossier, 'Text').then(respNumero => {

              // Send mail validation
              const categorieList = this.constructCategorieList();
              this._dataProviderLocal.validationCandidatureSendPdf(this.state.ConnectedLogin, this.state.IdCandidature, categorieList).then(respValidation => {

                // show success
                this.setState({ IsReady: true, IsSuccessSubmit: true, NumDossier: numeroDossier });
              });
            });
          });
        });
      });
    });

  }

  private constructCategorieList(): ICategorie[] {
    const categorieList: ICategorie[] = [];

    Object.keys(formulaireCandidature).map((key) => {
      const categorie: ICategorie = { categorieItems: [], categorieName: "" };
      categorie.categorieName = key;
      categorie.categorieItems = formulaireCandidature[key];
      categorieList.push(categorie);
    });

    return categorieList;
  }

  private getAllCandidature(): void {
    this._dataProvider.getInputValue(this.state.ConnectedLogin, '*', this.state.IdCandidature).then(valueRes => {

      this.setState({ CandidatureFieldsValue: valueRes.List }, () => {

        let isReadOnly = false;
        let promotionIsClosed = false;

        if (this.state.EtatDepotCandidatureList[0] !== this.state.CandidatureFieldsValue[0]["EtatDepotCandidature"]) {
          isReadOnly = true;
        }

        if (EnmUtils.promotionIsClosed(this.state.CandidatureFieldsValue[0]["IdPromo_x003a_DateFermeture"])) {
          isReadOnly = true;
          promotionIsClosed = true;
        }

        this.setState({ IsReadOnly: isReadOnly, PromotionIsClosed: promotionIsClosed }, () => {
          this.getAllCustomInputInfos();
        });
      });
    });
  }

  private getAllCustomInputInfos(): void {
    this._dataProvider.getAllCustomInput().then(valueRes => {
      this.setState({ AllCustomInputInfos: valueRes.List }, () => {
        this.getAllFormInputSharePoint();
      });
    });
  }

  private OnCategorieIsValid(categorieKey: string, categorieIsValid: boolean) {
    this.state = {
      ...this.state,
      CategorieInfos: {
        ...this.state.CategorieInfos,
        [categorieKey]: {
          ...this.state.CategorieInfos[categorieKey],
          IsValid: categorieIsValid,
        }
      }
    }

    let allIsValid = true;

    Object.keys(this.state.CategorieInfos).map((key, index) => {
      if (!this.state.CategorieInfos[key].IsValid) {
        allIsValid = false;
        return;
      }
    });

    this.setState({ ...this.state, AllCategorieIsValid: allIsValid });
  }

  private OnCategorieIsReady(categorieKey: string) {
    this.state = {
      ...this.state,
      CategorieInfos: {
        ...this.state.CategorieInfos,
        [categorieKey]: {
          ...this.state.CategorieInfos[categorieKey],
          IsReady: true,
        }
      }
    }

    let allIsReady = true;

    Object.keys(this.state.CategorieInfos).map((key, index) => {
      if (!this.state.CategorieInfos[key].IsReady) {
        allIsReady = false;
        return;
      }
    });

    this.setState({ ...this.state, AllCategorieIsReady: allIsReady });
  }

  private getAllFormInputSharePoint(): void {
    let allInputFormList: IInputFormSharePoint[] = [];

    this.state.AllCustomInputInfos.map(inputInfos => {

      const inputValidation: IInputValidation = {
        IsRequired: inputInfos['Required'],
        IsRequiredMessage: libelle.formulaireInput.requiredField,
        IsEmail: false,
        IsEmailMessage: '',
        IsEqualsToInput: '',
        IsEqualsToInputMessage: '',
        IsRegexMatch: '',
        IsRegexMatchMessage: '',
      }

      let inputSharePoint: IInputFormSharePoint = {
        Value: inputInfos['DefaultValue'] != null ? inputInfos['DefaultValue'] : '',
        IsValid: true,
        ToUpper: false,
        ToUpperFirstLetter: false,
        Message: '',
        InputValidation: inputValidation,
        Name: inputInfos['InternalName'],
        PlaceHolder: '',
        Type: inputInfos['Type'],
        Label: inputInfos['Description'],
        DisabledAutoComplet: false,
        DisabledPaste: false,
        InternalName: inputInfos['InternalName'],
        Choices: inputInfos['Choices'],
        TypeChoices: inputInfos['TypeChoices'],
        Description: inputInfos['Title'],
        Terms: inputInfos['Terms'],
        SendToSharePoint: true,
        IsReadOnly: this.state.IsReadOnly,
        IsVisible: true,
        ShowInputWhenValueEquals: '',
        IsFileInput: false,
      }

      // Gestion des contrôles bloquant la saisie de caractères alphabétiques
      // EL 20220208 : ajout du champs AutresDate (=année obtention autres diplomes)
      if (inputInfos['InternalName'] === 'NbEnfants'
        || inputInfos['InternalName'] === 'NbFS'
        || inputInfos['InternalName'] === 'NbFSEtude'
        || inputInfos['InternalName'] === 'AdrNum'
        || inputInfos['InternalName'] === 'AdrPereNum'
        || inputInfos['InternalName'] === 'AdrMereNum'
        || inputInfos['InternalName'] === 'AutresDate') {
        inputSharePoint = this.getCustomRegexValidationInput(inputSharePoint, configcustoms.Regex.NumberRegex, libelle.formulaireCandidature.numberRegexMessage);
      }

      // Gestion des contrôles bloquant la saisie de caractères alphabétiques autre qu'une virgule ou un point (pour les montants)
      // EL 20220208 : ajout des champs BoursesNMontant, ImportsPere, ImpotsMere, RevenuBrutGlobPere et RevenuBrutGlobMere
      if (inputInfos['InternalName'] === 'RvenuBrutGlobParents'
        || inputInfos['InternalName'] === 'ImpotsParents'
        || inputInfos['InternalName'] === 'RevenuBrutGlobCandidat'
        || inputInfos['InternalName'] === 'ImpotsCandidat'
        || inputInfos['InternalName'] === 'RevenuBrutGlobConjoint'
        || inputInfos['InternalName'] === 'ImpotsConjoint'
        || inputInfos['InternalName'] === 'BoursesNMontant'
        || inputInfos['InternalName'] === 'BoursesN1NMontant'
        || inputInfos['InternalName'] === 'BoursesN2N1Montant'
        || inputInfos['InternalName'] === 'BoursesN3N2Montant'
        || inputInfos['InternalName'] === 'BoursesN4N3Montant'
        || inputInfos['InternalName'] === 'ImpotsPere'
        || inputInfos['InternalName'] === 'ImpotsMere'
        || inputInfos['InternalName'] === 'RevenuBrutGlobPere'
        || inputInfos['InternalName'] === 'RevenuBrutGlobMere') {
        inputSharePoint = this.getCustomRegexValidationInput(inputSharePoint, configcustoms.Regex.DecimalRegex, libelle.formulaireCandidature.decimalRegexMessage);
      }

      // Gestion des contrôles sur les champs codes postaux
      if (inputInfos['InternalName'] === 'AdrCP'
        || inputInfos['InternalName'] === 'AdrBACCP'
        || inputInfos['InternalName'] === 'AdrPereCP'
        || inputInfos['InternalName'] === 'AdrMereCP') {
        inputSharePoint = this.getCustomRegexValidationInput(inputSharePoint, configcustoms.Regex.CodePostalRegex, libelle.formulaireCandidature.codePostalRegexMessage);
      }
      
      // Gestion des contrôles bloquant la saisie de caractères numériques
      // EL 20220208 : ajout des champs VilleNaissance, AdrVille, AdrBACVille, AdrPereVille, AdrMereVille, ProfPere et ProfMere
      if (inputInfos['InternalName'] === 'NomDeNaissance'
        || inputInfos['InternalName'] === 'NomMarital'
        || inputInfos['InternalName'] === 'Prenoms'
        || inputInfos['InternalName'] === 'AutresPrenoms'
        || inputInfos['InternalName'] === 'NomConjoint'
        || inputInfos['InternalName'] === 'PrenomConjoint'
        || inputInfos['InternalName'] === 'NomPere' 
        || inputInfos['InternalName'] === 'PrenomPere' 
        || inputInfos['InternalName'] === 'NomMere'
        || inputInfos['InternalName'] === 'PrenomMere'
        || inputInfos['InternalName'] === 'VilleNaissance'
        || inputInfos['InternalName'] === 'AdrVille'
        || inputInfos['InternalName'] === 'AdrBACVille'
        || inputInfos['InternalName'] === 'AdrPereVille'
        || inputInfos['InternalName'] === 'AdrMereVille'
        || inputInfos['InternalName'] === 'ProfPere'
        || inputInfos['InternalName'] === 'ProfMere') {
        inputSharePoint = this.getCustomRegexValidationInput(inputSharePoint, configcustoms.Regex.PasDeChiffresRegex, libelle.formulaireCandidature.PasDeChiffresRegexMessage);
      }

      // Formatage automatique de lettres minuscules en majuscules
      if (inputInfos['InternalName'] === 'NomDeNaissance'
        || inputInfos['InternalName'] === 'NomMarital'
        || inputInfos['InternalName'] === 'NomConjoint'
        || inputInfos['InternalName'] === 'NomPere'
        || inputInfos['InternalName'] === 'NomMere' ){
        inputSharePoint = {
          ...inputSharePoint,
          ToUpper: true
        }
      }

      // Formatage automatique de la 1ère lettre du champ en majuscule
      if (inputInfos['InternalName'] === 'Prenoms'
        || inputInfos['InternalName'] === 'AutresPrenoms'
        || inputInfos['InternalName'] === 'PrenomConjoint'
        || inputInfos['InternalName'] === 'PrenomPere'
        || inputInfos['InternalName'] === 'PrenomMere') {
        inputSharePoint = {
          ...inputSharePoint,
          ToUpperFirstLetter: true
        }
      }

      // Gestion des contrôles sur les champs Année (4 numériques)
      if (inputInfos['InternalName'] === 'SNDate'
        || inputInfos['InternalName'] === 'M2Date'
        || inputInfos['InternalName'] === 'M1Date'
        || inputInfos['InternalName'] === 'LICDate'
        || inputInfos['InternalName'] === 'BACDate'
        || inputInfos['InternalName'] === 'IEPDate'
        || inputInfos['InternalName'] === 'Candidature1Annee'
        || inputInfos['InternalName'] === 'Candidature2Annee'
        || inputInfos['InternalName'] === 'Candidature3Annee') {
        inputSharePoint = this.getCustomRegexValidationInput(inputSharePoint, configcustoms.Regex.AnneeRegex, libelle.formulaireCandidature.anneeRegexMessage);
      }

      // Gestion des contrôles sur les champs téléphones fixes
      if (inputInfos['InternalName'] === 'TelDomicile'
        || inputInfos['InternalName'] === 'TelPere'
        || inputInfos['InternalName'] === 'TelMere') {
        inputSharePoint = this.getCustomRegexValidationInput(inputSharePoint, configcustoms.Regex.InternationalPhoneRegex, libelle.formulaireCandidature.internationalPhoneRegexMessage);
      }

      // Gestion des contrôles sur les champs téléphones portables
      if (inputInfos['InternalName'] === 'TelPortable') {
        inputSharePoint = this.getCustomRegexValidationInput(inputSharePoint, configcustoms.Regex.PortableRegex, libelle.formulaireCandidature.portableRegexMessage);
      }

      if (inputInfos['InternalName'] === 'NationaliteFrancaise') {
        inputSharePoint = this.getCustomNationaliteFrancaiseInput(inputSharePoint);
      }

      if (inputInfos['InternalName'] === 'Courriel') {
        inputSharePoint = this.getCustomCourrielInput(inputSharePoint);
      }     

      // Mise en place du paramétrage pour gérer l'affichage conditionnel de certains champs
      if (inputInfos['InternalName'] === 'ParentsSepares') {
        inputSharePoint = this.getCustomParentsSeparesInput(inputSharePoint);
      }
      if (inputInfos['InternalName'] === 'SN') {
        inputSharePoint = this.getCustomSNInput(inputSharePoint);
      }
      if (inputInfos['InternalName'] === 'BoursesN') {
        inputSharePoint = this.getCustomBoursesNInput(inputSharePoint);
      }
      if (inputInfos['InternalName'] === 'BoursesN1') {
        inputSharePoint = this.getCustomBoursesN1Input(inputSharePoint);
      }
      if (inputInfos['InternalName'] === 'BoursesN2') {
        inputSharePoint = this.getCustomBoursesN2Input(inputSharePoint);
      }
      if (inputInfos['InternalName'] === 'BoursesN3') {
        inputSharePoint = this.getCustomBoursesN3Input(inputSharePoint);
      }
      if (inputInfos['InternalName'] === 'BoursesN4') {
        inputSharePoint = this.getCustomBoursesN4Input(inputSharePoint);
      }

      // EL 20220208 : Gestion du critère obligatoire sur les champs soumis à une condition d'affichage :
      if (inputInfos['InternalName'] === 'BoursesNIntitule'
        || inputInfos['InternalName'] === 'BoursesNNature'
        || inputInfos['InternalName'] === 'BoursesN1NIntitule'
        || inputInfos['InternalName'] === 'BoursesN1NNature'
        || inputInfos['InternalName'] === 'BoursesN2N1Intitule'
        || inputInfos['InternalName'] === 'BoursesN2N1Nature'
        || inputInfos['InternalName'] === 'BoursesN3N2Intitule'
        || inputInfos['InternalName'] === 'BoursesN3N2Nature'
        || inputInfos['InternalName'] === 'BoursesN4N3Intitule'
        || inputInfos['InternalName'] === 'BoursesN4N3Nature'
        || inputInfos['InternalName'] === 'SNDate') {
        inputSharePoint = this.getCustomInputRequired(inputSharePoint);
      }

      if (this.state.CandidatureFieldsValue[0] != null && this.state.CandidatureFieldsValue[0][inputSharePoint.InternalName] != null) {
        let value = this.state.CandidatureFieldsValue[0][inputSharePoint.InternalName];
        if (inputSharePoint.Type === "DateTime") {
          value = this.state.CandidatureFieldsValue[0][inputSharePoint.InternalName] === '' ? null : new Date(this.state.CandidatureFieldsValue[0][inputSharePoint.InternalName]);
        }
        if (inputSharePoint.Type === "Note") {
          const tmp = this.state.CandidatureFieldsValue[0][inputSharePoint.InternalName] as string;
          value = tmp.replace(/<.*?>/gi, "")
        }
        inputSharePoint = { ...inputSharePoint, Value: value };
      }

      formulaireAllPjList.map(PJInput => {
        if (inputInfos['InternalName'] === PJInput) {
          inputSharePoint.IsFileInput = true;
        }
      });

      const inputFormList: IInputFormSharePoint[] = [];

      inputFormList[inputInfos['InternalName']] = {
        ...inputSharePoint
      }

      if (inputSharePoint.IsFileInput) {
        inputFormList[inputInfos['InternalName'] + '_file'] = {
          ...this.getCustomFileInput(inputSharePoint)
        }
      }

      allInputFormList = {
        ...allInputFormList,
        ...inputFormList
      }
    });

    this.setState({ InputFormSharePointList: allInputFormList }, () => {
      this.getAllPJList();
    });
  }

  private getAllPJList(): void {

    this._dataProvider.getPJList(this.state.ConnectedLogin, this.state.IdCandidature).then(resp => {
      this.setState({ IsReady: true, PJSharePointList: resp.List });
    });

  }  

  // EL 20220208 : Gestion du critère obligatoire
  private getCustomInputRequired(inputSharePoint: IInputFormSharePoint): IInputFormSharePoint {
    return {
      ...inputSharePoint,
      InputValidation: {
        ...inputSharePoint.InputValidation,
        IsRequired: true,
      }
    }
  }

  private getCustomRegexValidationInput(inputSharePoint: IInputFormSharePoint, regex: string, regexMessage: string) {
    return {
      ...inputSharePoint,
      InputValidation: {
        ...inputSharePoint.InputValidation,
        IsRegexMatch: regex,
        IsRegexMatchMessage: regexMessage,
      }
    }
  }

  private getCustomNationaliteFrancaiseInput(inputSharePoint: IInputFormSharePoint): IInputFormSharePoint {
    return {
      ...inputSharePoint,
      InputValidation: {
        ...inputSharePoint.InputValidation,
        IsNotEqualsToValue: 'Non',
        IsNotEqualsToValueMessage: libelle.formulaireInput.requiredNationalite
      }
    }
  }

  private getCustomCourrielInput(inputSharePoint: IInputFormSharePoint): IInputFormSharePoint {
    return {
      ...inputSharePoint,
      InputValidation: {
        ...inputSharePoint.InputValidation,
        IsEmail: true,
        IsEmailMessage: libelle.formulaireInput.errorEmail
      }
    }
  }

  private getCustomTelNumberInput(inputSharePoint: IInputFormSharePoint): IInputFormSharePoint {
    return {
      ...inputSharePoint,
      InputValidation: {
        ...inputSharePoint.InputValidation,
        IsTelNumber: true,
        IsTelNumberMessage: libelle.formulaireInput.errorTel
      }
    }
  }

  // EL 20220208 : Méthodes permettant de paramétrer l'affichage conditionnel de certains champs
  // ShowInputListId : contient les champs liés au champ en cours de traitement (inputSharePoint)
  // ShowInputWhenValueEquals : contient la valeur qui déclenche l'affichage des champs liés
  private getCustomBoursesNInput(inputSharePoint: IInputFormSharePoint): IInputFormSharePoint {
    return {
      ...inputSharePoint,
      ShowInputWhenValueEquals: 'Oui',
      ShowInputListId: ['BoursesNMontant', 'BoursesNIntitule', 'BoursesNNature']
    }
  }
  private getCustomBoursesN1Input(inputSharePoint: IInputFormSharePoint): IInputFormSharePoint {
    return {
      ...inputSharePoint,
      ShowInputWhenValueEquals: 'Oui',
      ShowInputListId: ['BoursesN1NMontant', 'BoursesN1NIntitule', 'BoursesN1NNature']
    }
  }
  private getCustomBoursesN2Input(inputSharePoint: IInputFormSharePoint): IInputFormSharePoint {
    return {
      ...inputSharePoint,
      ShowInputWhenValueEquals: 'Oui',
      ShowInputListId: ['BoursesN2N1Montant', 'BoursesN2N1Intitule', 'BoursesN2N1Nature']
    }
  }
  private getCustomBoursesN3Input(inputSharePoint: IInputFormSharePoint): IInputFormSharePoint {
    return {
      ...inputSharePoint,
      ShowInputWhenValueEquals: 'Oui',
      ShowInputListId: ['BoursesN3N2Montant', 'BoursesN3N2Intitule', 'BoursesN3N2Nature']
    }
  }
  private getCustomBoursesN4Input(inputSharePoint: IInputFormSharePoint): IInputFormSharePoint {
    return {
      ...inputSharePoint,
      ShowInputWhenValueEquals: 'Oui',
      ShowInputListId: ['BoursesN4N3Montant', 'BoursesN4N3Intitule', 'BoursesN4N3Nature']
    }
  }
  private getCustomSNInput(inputSharePoint: IInputFormSharePoint): IInputFormSharePoint {
    return {
      ...inputSharePoint,
      ShowInputWhenValueEquals: 'Effectué',
      ShowInputListId: ['SNDate']
    }
  }
  private getCustomParentsSeparesInput(inputSharePoint: IInputFormSharePoint): IInputFormSharePoint {
    return {
      ...inputSharePoint,
      ShowInputWhenValueEquals: 'Oui',
      ShowInputListId: ['RevenuBrutGlobPere', 'ImpotsPere', 'RevenuBrutGlobMere', 'ImpotsMere']
    }
  }

  // Gestion spécifique pour les champs de type fichier
  private getCustomFileInput(inputSharePoint: IInputFormSharePoint): IInputFormSharePoint {

    var extensionsArray = configcustoms.Other.FileFormat.split(',');
    if (inputSharePoint.InternalName === 'PJPhotoIdentite') {
      extensionsArray = configcustoms.Other.ImageFormat.split(',');
    }
    const inputFileValidation: IInputValidation = {
      IsRequired: inputSharePoint.InputValidation.IsRequired,
      IsRequiredMessage: libelle.formulaireFileInput.requiredField,
      IsEmail: false,
      IsEmailMessage: '',
      IsEqualsToInput: '',
      IsEqualsToInputMessage: '',
      IsRegexMatch: '',
      IsRegexMatchMessage: '',
      IsMaxSizeMo: configcustoms.Other.MaxFileSize,
      IsMaxSizeMoMessage: libelle.formulaireFileInput.fileToBig.replace('{0}',  configcustoms.Other.MaxFileSize),
      IsExtensions: extensionsArray,
      IsExtensionsMessage: libelle.formulaireFileInput.extensionError + " " + extensionsArray.join(', '),
    }

    const inputFileSharePoint: IInputFormSharePoint = {
      Value: '',
      IsValid: true,
      Message: '',
      ToUpper: false,
      ToUpperFirstLetter: false,
      InputValidation: inputFileValidation,
      Name: inputSharePoint.InternalName + "_file",
      PlaceHolder: '',
      Type: 'File',
      Label: inputSharePoint.Label,
      DisabledAutoComplet: false,
      DisabledPaste: false,
      InternalName: '',
      Choices: '',
      Description: inputSharePoint.Description,
      SendToSharePoint: false,
      IsReadOnly: inputSharePoint.IsReadOnly,
      IsVisible: true,
      ShowInputWhenValueEquals: '',
      Terms:[],
    }

    if (inputSharePoint.InternalName === 'PJPhotoIdentite') {

      inputFileSharePoint.InputValidation.IsExtensions = configcustoms.Other.ImageFormat.split(',');
      inputFileSharePoint.InputValidation.IsDimensionsHeight = configcustoms.Other.MinHeigtImageDimension;
      inputFileSharePoint.InputValidation.IsDimensionsWidth = configcustoms.Other.MinWidthImageDimension;
      inputFileSharePoint.InputValidation.IsDimensionsMessage = libelle.formulaireFileInput.dimensionsMessageError + " " + configcustoms.Other.MinWidthImageDimension + "x" + configcustoms.Other.MinHeigtImageDimension;
    }

    return inputFileSharePoint;
  }

  private OnInputChange(inputChange: IInputFormSharePoint): void {

    this.setState({ InputFormSharePointList: { ...this.state.InputFormSharePointList, [inputChange.InternalName]: inputChange } });
  }

  private getEtatCandidature(): Promise<void> {

    return this._dataProvider.getInput("EtatCandidature").then(resp => {
      this.setState({ EtatCandidatureList: resp.List[0].Choices.split(';') });
    });
  }

  private getEtatDepotCandidature(): Promise<void> {

    return this._dataProvider.getInput("EtatDepotCandidature").then(resp => {
      this.setState({ EtatDepotCandidatureList: resp.List[0].Choices.split(';') });
    });
  }

}

export default hot(module)(FormulaireCandidature);
